import React, { useState, useEffect } from "react";
import App from "./App";
import "./App.css";
import { useLocation } from 'react-router-dom';
function AppWrapper() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  
  useEffect(() => {
    // Route change par service worker update check
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.getRegistration().then((registration) => {
        if (registration) {
          registration.update();
        }

         // Handle service worker updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New service worker available
                console.log('New version available! Auto-refreshing...');
                
                // Skip waiting and reload
                newWorker.postMessage({ type: 'SKIP_WAITING' });
                
                // Wait for new service worker to take control, then reload
                navigator.serviceWorker.addEventListener('controllerchange', () => {
                  window.location.reload();
                });
              }
            });
          });
      });
    }
  }, [location.pathname]);

  useEffect(() => {
    // Simulate initial app load or API call
    const timer = setTimeout(() => setIsLoading(false), 2000); // 2s loader
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    // Full screen skeleton loader
    return (
      <div className="loader">
        <span></span>
        <span></span>
        <span></span>
      </div>
    );
  }

  return <App />;
}

export default AppWrapper;
